"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));
    _this.state = {
      checked: false
    };
    _this.setCheckbox = _this.setCheckbox.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        checked: false
      });

      if (this.props.selectedItems.map(function (i) {
        return i.id;
      }).indexOf(this.props.item.id) >= 0) {
        this.setState({
          checked: true
        });
      }

      if (this.props.selectedFilters[this.props.item.parameterName] && this.props.selectedFilters[this.props.item.parameterName].map(function (i) {
        return i.value;
      }).indexOf(this.props.item.value) >= 0) {
        this.setState({
          checked: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var checked = false;

      if (this.props.selectedItems.map(function (i) {
        return i.id;
      }).indexOf(this.props.item.id) >= 0) {
        checked = true;
      }

      if (this.props.selectedFilters[this.props.item.parameterName] && this.props.selectedFilters[this.props.item.parameterName].map(function (i) {
        return i.value;
      }).indexOf(this.props.item.value) >= 0) {
        checked = true;
      }

      return /*#__PURE__*/_react.default.createElement("li", {
        key: this.props.item.id,
        onClick: function onClick() {
          return _this2.setCheckbox();
        },
        className: "filter-menu-item ".concat(this.props.disabled ? 'disabled' : '')
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "checkbox",
        className: "filter-menu-check",
        checked: checked
      }), /*#__PURE__*/_react.default.createElement("label", null, this.props.item.name));
    }
  }, {
    key: "setCheckbox",
    value: function setCheckbox() {
      this.setState({
        checked: !this.state.checked
      });
      this.props.onItemClick(this.props.item);
    }
  }]);

  return Checkbox;
}(_react.default.Component);

Checkbox.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  item: _propTypes.default.shape({
    id: _propTypes.default.any,
    name: _propTypes.default.string,
    parameterName: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  stringItems: _propTypes.default.array,
  selectedItems: _propTypes.default.array,
  selectedFilters: _propTypes.default.object,
  onCloseFilterClick: _propTypes.default.func,
  onResetFilterClick: _propTypes.default.func,
  onItemClick: _propTypes.default.func,
  onShowResultsClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
var _default = Checkbox;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-filter/lib/checkbox.js
// module id = 876
// module chunks = 0